import { privilegesToResources, resourcesToPrivileges } from '_src/utils';

const transformAll = privilegesRes => {
  let privileges = privilegesRes?.data?.resources ?? [];
  const total = privilegesRes?.data?.total || 0;

  privileges = privileges.map(({ resource, ...rest }) => ({
    id: resource,
    resource,
    ...rest
  }));
  return {
    data: privileges,
    total
  };
};

const transformGroups = groupRes => {
  let groups = groupRes?.data?.groups ?? [];

  return { groups };
};

const transformLocations = branchesRes => {
  return (branchesRes.data?.branches || [])
    .sort((a, b) => a.name.localeCompare(b.name))
    .reduce((acc, { id, name }) => {
      let items = [
        {
          id,
          label: `${name}`
        }
      ];
      return [...acc, ...items];
    }, []);
};

export { transformAll, transformGroups, transformLocations };
